import { render } from "./ProductionLinksPage.vue?vue&type=template&id=4ac2395e"
import script from "./ProductionLinksPage.vue?vue&type=script&lang=js"
export * from "./ProductionLinksPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__